"use strict";

var _interopRequireDefault = require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRMLocations = exports.getRMLocationUnchangeRank = exports.defaultRMLocationData = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
const defaultRMLocationData = exports.defaultRMLocationData = {
  id: null,
  name: ''
};
// export const getRMLocations = (data: any) =>
//   request({
//     url: '/rm-locations/zone',
//     method: 'post',
//     data
//   })
const getRMLocations = params => (0, _request.default)({
  url: '/rm-locations',
  method: 'get',
  params
});
exports.getRMLocations = getRMLocations;
const getRMLocationUnchangeRank = params => (0, _request.default)({
  url: '/rm-scores-weekly',
  method: 'get',
  params
});
exports.getRMLocationUnchangeRank = getRMLocationUnchangeRank;